// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"ec8783e6","54":"ec8783e6","236":"ec8783e6","321":"ec8783e6","346":"c8b31a99","381":"ec8783e6","586":"ec8783e6","638":"ec8783e6","769":"ec8783e6","827":"ec8783e6","961":"ec8783e6"}[chunkId] + ".chunk.css";
};